import { Component, OnInit, TemplateRef } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import {
	PARAM_LABEL_BENEFICIAIRE,
	PARAM_LABEL_INTERVENANT,
	PARAM_LABEL_INTERVENTION
} from 'src/app/core/services/constant/constants.service';
import { FacadeService } from 'src/app/core/services/facade.service';
import { LogService } from 'src/app/core/services/log/log.service';
import { Prestation } from 'src/app/shared/models/prestation';
import { Employee } from 'src/app/shared/models/employee/employee';
import { MissionRequest } from 'src/app/shared/models/mission/mission-request';
import { ResitutionTypeEnumString, RestitutionPrestation, StatutProlongationEnumString } from 'src/app/shared/models/restitutionPrestation';
import { ErrorResponse } from 'src/app/shared/models/api-response/error-response';
import { ToastService } from 'src/app/core/services/toast/toast.service';
import { Router } from '@angular/router';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DateUtils } from 'src/app/shared/utils/date-utils';

@Component({
	selector: 'app-modal-content',
	templateUrl: './prestation-modal-detail-restitutionPrestation.component.html',
	styleUrls: ['./prestation-modal-detail-restitutionPrestation.component.scss']
})
export class PrestationModalDetailRestitutionPrestationComponent implements OnInit {
	/**
	 * Prestation, transmit par le service Modal de ngx dans PrestationModalDetailRestitutionPrestationComponent
	 */
	prestation: Prestation;

	/**
	 * MissionRequest, transmit par le service Modal de ngx dans PrestationModalDetailRestitutionPrestationComponent
	 */
	restitutionPrestation: RestitutionPrestation;

	competences;

	isSESSAD = false;
	isSAAD = false;
	isSSIAD = false;
	confirmDeleteModalRef: BsModalRef;

	isFormReadOnly = true;

	uniqueEmployeeOfMission: Employee;

	LABEL_INTERVENTION: string;

	isValidateButtonClicked: { value: boolean } = { value: false };
	ResitutionTypeEnumString = ResitutionTypeEnumString;
	StatutProlongationEnumString = StatutProlongationEnumString;

	form: FormGroup = new FormGroup(
		{
			dateValidQualif: new FormControl<Date>(null),
			dateButoirDepot: new FormControl<Date>(null),
			dateDepotRestFinale: new FormControl<Date>(null),
			type: new FormControl(''),
			prolongation: new FormControl(''),
			dateDemarrage: new FormControl<Date>(null),
			date1erRv: new FormControl<Date>(null),
			dateFinPrev: new FormControl<Date>(null),
			heuresPrev: new FormControl(''),
			totalHeures: new FormControl(''),
			heuresBilaterales: new FormControl(''),
			heuresCollectif: new FormControl(''),
			heuresEmployeur: new FormControl(''),
			totalHeuresRestantes: new FormControl(''),
			mobilisationAutreAs: new FormControl(''),
			raisonSocialeAutre: new FormControl(''),
			pointVigilance: new FormControl(''),
			organismePecBenef: new FormControl(''),
			consequencesHandicap: new FormControl(''),
			reponsesIdentifiees: new FormControl(''),
			aidesTechniques: new FormControl(''),
			aidesHumaines: new FormControl(''),
			aidesOrganisationnelles: new FormControl(''),
			mediation: new FormControl(''),
			statutDemandeProlongation: new FormControl(''),
			demarcheAdministrative: new FormControl(''),
			demarcheAdministrativeDetails: new FormControl(''),
		}
	);

	constructor(
		public bsModalRef: BsModalRef,
		private facade: FacadeService,
		private logger: LogService,
		private toastService: ToastService,
		private modalService: BsModalService,
		private router: Router,
		private dateUtils: DateUtils
	) { }

	ngOnInit(): void {

	}

	get LABEL_INTERVENANT() {
		return this.facade.dataStorageService.getLabelCapitalized(
			PARAM_LABEL_INTERVENANT
		);
	}

	get LABEL_BENEFICIAIRE() {
		return this.facade.dataStorageService.getLabelCapitalized(
			PARAM_LABEL_BENEFICIAIRE
		);
	}

	getEmployeeOfMission() {
		const employeeName = this.uniqueEmployeeOfMission
			? this.uniqueEmployeeOfMission.firstName +
			' ' +
			this.uniqueEmployeeOfMission.lastName
			: 'Aucun';
		return employeeName;
	}

	openModal(confirmDeleteTemplate: TemplateRef<any>): void {
		this.confirmDeleteModalRef = this.modalService.show(confirmDeleteTemplate);
	}

	editForm(): void {
		this.isFormReadOnly = false;
	}

	stopEditForm(): void {
		this.form.reset();
		this.isFormReadOnly = true;
		this.isValidateButtonClicked.value = false;
	}

	delete(restitutionPrestation: RestitutionPrestation): void {
		this.facade.restitutionPrestationService
			.deleteRestitutionPrestation(restitutionPrestation.id)
			.subscribe({
				complete: () => {
					this.modalService.hide();
					this.reload();
				},
				error: (err: ErrorResponse) => {
					this.toastService.createHttpErrorToast(
						err.error.message,
						err.status
					);
				}
			});
	}

	reload() {
		const currentUrl = this.router.url;
		this.router.routeReuseStrategy.shouldReuseRoute = () => false;
		this.router.onSameUrlNavigation = 'reload';
		this.router.navigate([currentUrl]);
	}

	onSubmit() {
		this.isValidateButtonClicked.value = true;
		this.facade.restitutionPrestationService
			.updateRestitutionPrestation(this.restitutionPrestation)
			.subscribe({
				complete: () => {
					this.modalService.hide();
					this.isValidateButtonClicked.value = false;
					this.reload();
				},
				error: (err: ErrorResponse) => {
					this.isValidateButtonClicked.value = false;
					this.toastService.createHttpErrorToast(
						err.error.message,
						err.status
					);
				}
			});
	}


}
